var map = {
	"./en.json": [
		48083,
		8083
	],
	"./es.json": [
		81000,
		1000
	],
	"./pt-BR.json": [
		35549,
		5549
	],
	"./toast-en.json": [
		50221,
		221
	],
	"./toast-es.json": [
		92002,
		2002
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 57146;
module.exports = webpackAsyncContext;